import React from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';
import styles from './footer.scss';

import { Text } from 'wix-style-react';

const Footer = ({ t }) => (
  <div data-hook="mi-facebook-catalog-link-footer" className={styles.container}>
    <Text size="small" secondary>
      {t('facebook-catalog.modal.footer')}
    </Text>
  </div>
);

Footer.propTypes = {
  t: func.isRequired,
};

export default translate()(Footer);
